<template>
  <div>
    <el-table :data="data" border stripe style="width: 100%">
      <el-table-column label="料场标识牌" prop="signName" width="auto" align="center" />
      <el-table-column label="料场标识牌图片" width="auto" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.identificationUrl"
            type="text"
            size="small"
            @click="showFiles(scope.row.identificationUrl)"
          >查看</el-button>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="材料" prop="materialQuality" width="auto" align="center" />
      <el-table-column label="是否有异物" prop="foreignBodyEvaluation" width="auto" align="center" />
      <el-table-column label="色差" prop="colorDifference" width="auto" align="center" />
      <el-table-column label="材料图片" width="auto" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.materialPictureUrl"
            type="text"
            size="small"
            @click="showFiles(scope.row.materialPictureUrl)"
          >查看</el-button>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="提交时间" prop="createTime" width="auto" align="center" />
      <el-table-column label="提交人" prop="createUserName" width="auto" align="center" />
    </el-table>
    <LookFile
      :visible.sync="lookFileVisible"
      :config="lookFileConfig"
      @update:visible="handleDialogClose"
    />
  </div>
</template>

<script>
import LookFile from '@/components/File/LookFile.vue'

export default {
  name: 'LogMaterialTable',
  components: { LookFile },
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      lookFileVisible: false,
      lookFileConfig: { filePaths: '' },
    }
  },
  methods: {
    parseFiles(fieldValue) {
      if (!fieldValue) return []
      try {
        const arr = JSON.parse(fieldValue)
        if (Array.isArray(arr)) {
          return arr.map(item => ({
            fileName: item.fileName || '未命名文件',
            filePath: item.filePath ? `https://lvshe.huashijc.com/file/${item.filePath}` : ''
          }))
        }
        return []
      } catch (e) {
        console.error('解析文件字段失败:', e)
        return []
      }
    },
    // 显示文件预览弹窗
    showFiles(fieldValue) {
      const files = this.parseFiles(fieldValue)
      if (files.length === 0) {
        this.$message.warning('无有效文件')
        return
      }
      this.lookFileConfig.filePaths = JSON.stringify(files)
      this.lookFileVisible = true
    },
    handleDialogClose() {
      this.lookFileVisible = false
    },
    handleViewDetail(row) {
      this.$emit('viewDetail', row)
    }
  }
}
</script>